<template>
  <div class="por df-upload flex fww"
       :style="{width, minHeight: uploadHeight + 'px'}">
    <div class="por dib vam"
         :style="{width: size, height: uploadHeight + 'px'}"
         v-show="showUploadBox">
      <Upload :action="uploadLink"
              :on-success="success"
              :on-error="error"
              :before-upload="before"
              :show-upload-list="showList"
              :data="data"
              :disabled="disabled"
              :multiple="multiple"
              :headers="sendHeaders"
              :accept="accept">
        <div class="poa t0 l0 w100">
          <div class=""
               ref="upload">
            <slot>
              <div class="upload-inner por unselect csp">
                <div class="poa w100 h100 t0 l0 flex jcc aic">
                  <div class="h100 w100 img-inner"
                       :style="{backgroundImage: `url(${src})`}"
                       v-if="src">
                    <div class="poa w100 h100 img-inner-bg flex t0 l0 jce aic"
                         v-show="showCtrl">
                      <Icon type="ios-search" />
                      <Icon type="ios-trash" />
                    </div>
                  </div>
                  <Icon type="md-add no-img"
                        v-else />
                </div>
              </div>
            </slot>
          </div>
        </div>
      </Upload>
    </div>
    <template v-if="multiple">
      <div class="img-item dib vam por upload-inner ovh csp img-inner unselect"
           @mousedown="moving(i)"
           @drag.stop.prevent
           @mouseup="moving(i, 1)"
           :style="{width: (imgHight || uploadHeight) + 'px', minHeight: (imgHight || uploadHeight) + 'px'}"
           v-for="(item, i) in list"
           :key="i">
        <img :src="item[srcKey]"
             alt=""
             class="w100 h100 vam img-item-inner" />
        <div class="poa w100 h100 img-inner-bg flex t0 l0 jce aic">
          <!-- <Icon type="ios-search"
                @click="searchSrc(item[srcKey])" /> -->
          <Icon type="ios-trash"
                @click="delSrc(item, i)" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { new_api_url } from '@/config/config';

export default {
  name: "DfUpload",
  computed: {
    uploadLink () {
      let action = this.action;
      return /^https?/.test(action) ? action : new_api_url + action;
    },
    sendHeaders () {
      return {
        'x-token': this.$store ? this.$store.getters.newApiToken : this.xToken,
        ...this.headers
      };
    },
    file () {
      return this.fileList[this.fileList.length - 1];
    },
  },
  props: {
    action: {
      type: String,
      default: 'tool/upload/up'
    },
    value: {
      type: String | Array,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'savename'
    },
    showSrc: {
      type: String | Array,
      default: ''
    },
    srcKey: {
      type: String,
      default: 'domain'
    },
    size: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '40%'
    },
    showList: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    uploadNow: {
      type: Boolean,
      default: false
    },
    length: {
      type: Number | String,
    },
    showCtrl: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default () {
        return {};
      },
    },
    headers: {
      type: Object,
      default () {
        return {};
      },
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    xToken: {
      type: String,
      default: ''
    },
    res: {
      type: Object | Array,
      default () {
        return {};
      }
    },
    showLoading:{
      type: Boolean,
      default: false
    },
    imgHight: {
      type: String,
      default: ''
    },
    delIcon: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      loading: false,
      showUploadBox: true,
      uploadHeight: '',
      list: [],
      listLen: 0,
      move: '',
      fileList: [],
      src: '',
    };
  },
  watch: {
    list () {
      this.listLen = this.list.length;
      this.setUploadShow();
    },
    length () {
      this.setUploadShow();
    },
  },
  created () {
    this.initSrc();
  },
  mounted () {
    this.$nextTick(() => {
      let uploads = this.$refs.upload;
      uploads && (this.uploadHeight = uploads.offsetHeight);
    });
  },
  methods: {
    setUploadShow () {
      let { length, list } = this;
      this.$nextTick(() => {
        this.showUploadBox = length === undefined || length > list.length;
      });
    },
    async submit () {
      if (this.fileList) {
        if( this.fileList.length && this.showLoading){
          const show = this.$Message.loading({
                  content: '正在上传中...',
                  duration: 0
                });
        }
        try {
          let resObj = {};
          let resArr = await Promise.all(this.fileList.map((file) => this.http.upload(this.uploadLink, {
            file,
            data: this.data
          }, {
            headers: this.sendHeaders
          }).then(res => {
            this.$Message.destroy()
            if (+res.data.code !== 200) throw res.data;
            resObj = res.data;
            return { res: res.data, file };
          })
          ));
          resArr.forEach(({ res, file }) => {
            this.success(res, file, this.fileList);
          });
          Object.assign(resArr, resObj);
          return resArr;
        } catch (e) {
          this.$Message.destroy()
          this.error(e, null, this.fileList);
          throw e;
        }
      }
    },
    moving (i, end) {
      if (end && this.move !== i) {
        let s = this.list[this.move];
        let e = this.list.splice(i, 1, s)[0];
        this.list.splice(this.move, 1, e);
        this.success();
      } else {
        this.move = i;
      }
    },
    searchSrc (src) {
      // this.ShowFormModel({ imageList: [src || this.src] });
      this.$Modal.confirm({
                    content: '<p>Content of dialog</p><p>Content of dialog</p>',
                    button: [],
                });
    },
    delSrc (item, i) {
      if (item) {
        this.list.splice(i, 1);
        item.__index && this.fileList.splice(item.__index, 1);
        this.success();
      } else {
        this.src = '';
        this.value = '';
        this.fileList = [];
        this.$emit('input', this.value);
        this.$emit('success', {}, null, []);
      }
    },

    initSrc () {
      let { res, srcKey, showSrc, value, valueKey } = this;
      if (Array.isArray(value)) {
        let showList = Array.isArray(showSrc) ? showSrc : [];
        this.list = value.map((src, i) => {
          let obj = {};
          obj[srcKey] = src[srcKey] || showList[i] || '';
          obj[valueKey] = src[valueKey] || src || '';
          return obj;
        });
        this.src = '';
      } else if (res[srcKey]) {
        this.src = res[srcKey];
      } else {
        this.src = this.showSrc;
      }
    },

    async before (file, fileList) {
      this.loading = true;
      if (this.uploadNow) return file;
      this.listLen++;
      // return;
      this.fileList = this.fileList || [];
      fileList = this.fileList;
      if (this.multiple) {
        let f = file;
        if (this.listLen <= this.length) {
          let obj = { code: 200, data: {} };
          obj.data[this.srcKey] = await this.Tools.img2base(f);
          obj.data[this.valueKey] = f.name;
          obj.data.size = f.size;
          obj.data.__index = fileList.length;
          this.success(obj, file, fileList);
          this.fileList.push(file);
        }
      } else {
        let res = { code: 200, data: {} };
        res.data[this.srcKey] = await this.Tools.img2base(file);
        res.data[this.valueKey] = file.name;
        res.data.size = file.size;
        this.fileList.splice(0, 1, file);
        this.success(res, file, fileList);
      }
      throw false;
    },
    error (err, file, fileList) {
      this.loading = false;
      this.$emit('error', err, file, fileList);
    },
    success (res, file, fileList = this.fileList) {
      if (!res) {
        let list = [...this.list];
        this.value = list.map(e => e[this.valueKey]);
        this.$emit('input', this.value);
        this.$emit('success', this.value, list, []);
      } else if (+res.code === 200) {
        this.loading = false;
        if (this.multiple) {
          this.src = '';
          let ind = this.list.indexOf(this.list.find(e => e[this.valueKey] === file.name));
          if (ind !== -1) {
            this.list.splice(ind, 1, res.data);
          } else {
            this.list.push(res.data);
          }
          return this.success();
        } else {
          this.src = res.data[this.srcKey];
          this.value = res.data[this.valueKey];
        }
        this.$emit('input', res.data[this.valueKey]);
        this.$emit('success', res.data, file, fileList);
      } else {
        this.error(res, file, fileList);
      }
    },
  },
}
</script>

<style scoped lang="less">
.upload-inner {
  padding-top: 100%;
  border: 1px solid #d5d5d5;
  border-radius: 5px;
  box-shadow: 0 0 3px #d5d5d5;
  &.img-item {
    margin: 0 10px 10px 0;
    padding: 0;
  }
  .img-item-inner {
    border-radius: 5px;
  }
}

.no-img {
  font-size: 30px;
}

.img-inner {
  background: no-repeat center center / 100% 100%;
  &:hover {
    .img-inner-bg {
      opacity: 1;
    }
  }
  .ivu-icon {
    &:hover {
      color: #57a3f3;
    }
  }
}

.img-inner-bg {
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  transition: opacity 0.3s;
  font-size: 30px;
}

.new-del{
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
}
</style>